import {
  ADD_CUSTOMER_START,
  ADD_CUSTOMER_SUCCESS,
  ADD_CUSTOMER_FAILURE,
  ADD_CUSTOMER_RESET,
  GET_CUSTOMER_START,
  GET_CUSTOMER_SUCCESS,
  GET_CUSTOMER_FAILURE,
  GET_CUSTOMER_RESET,
  EDIT_CUSTOMER_START,
  EDIT_CUSTOMER_SUCCESS,
  EDIT_CUSTOMER_FAILURE,
  EDIT_CUSTOMER_RESET,
  DELETE_CUSTOMER_START,
  DELETE_CUSTOMER_SUCCESS,
  DELETE_CUSTOMER_RESET,
  DELETE_CUSTOMER_FAILURE,
  VIEW_CUSTOMER_START,
  VIEW_CUSTOMER_SUCCESS,
  VIEW_CUSTOMER_FAILURE,
  VIEW_CUSTOMER_RESET,
  GET_CUSTOMER_TYPE_START,
  GET_CUSTOMER_TYPE_SUCCESS,
  GET_CUSTOMER_TYPE_FAILURE,
  GET_CUSTOMER_TYPE_RESET,
  ADD_CUSTOMER_FOLLOWUP_START,
  ADD_CUSTOMER_FOLLOWUP_SUCCESS,
  ADD_CUSTOMER_FOLLOWUP_FAILURE,
  ADD_CUSTOMER_FOLLOWUP_RESET,
  GET_CUSTOMER_FOLLOWUP_START,
  GET_CUSTOMER_FOLLOWUP_SUCCESS,
  GET_CUSTOMER_FOLLOWUP_FAILURE,
  GET_CUSTOMER_FOLLOWUP_RESET,
  GET_CUSTOMER_PROFILE_START,
  GET_CUSTOMER_PROFILE_SUCCESS,
  GET_CUSTOMER_PROFILE_FAILURE,
  GET_CUSTOMER_PROFILE_RESET,
  UPDATE_CUSTOMER_PROFILE_START,
  UPDATE_CUSTOMER_PROFILE_SUCCESS,
  UPDATE_CUSTOMER_PROFILE_FAILURE,
  UPDATE_CUSTOMER_PROFILE_RESET,
  CUSTOMER_ID_RESET,
  GET_CUSTOMER_NAME_START,
  GET_CUSTOMER_NAME_SUCCESS,
  GET_CUSTOMER_NAME_FAILURE,
  GET_CUSTOMER_NAME_RESET,
  UPLOAD_FILE_START,
  UPLOAD_FILE_SUCCESS,
  UPLOAD_FILE_FAIL,
  GET_UPLOADED_FILE_START,
  GET_UPLOADED_FILE_SUCCESS,
  GET_UPLOADED_FILE_FAILURE,
  GET_UPLOADED_FILE_RESET,
  CREATE_UPLOAD_LINK_START,
  CREATE_UPLOAD_LINK_SUCCESS,
  CREATE_UPLOAD_LINK_FAIL,
  UPOLOAD_FILE_LINK_START,
  UPOLOAD_FILE_LINK_SUCCESS,
  UPOLOAD_FILE_LINK_FALSE,
  CUST_VIEWFILE_START,
  CUST_VIEWFILE_SUCCESS,
  CUST_VIEWFILE_FAIL,
  DELETE_FILE_FAILURE,
  DELETE_FILE_SUCCESS,
  DELETE_FILE_START,
  DELETE_FILE_RESET,
  GET_BLOCKED_CUST,
  GET_BLOCKED_CUST_SUCCESS,
  GET_BLOCKED_CUST_FAILED,
  EDIT_CUST_FILES,
  EDIT_CUST_FILES_SUCCESS,
  EDIT_CUST_FILES_FAILED
} from "./actiontypes"

// add Customer

export const addCustomerStart = payload => ({
  type: ADD_CUSTOMER_START,
  payload,
})

export const addCustomerSuccess = payload => ({
  type: ADD_CUSTOMER_SUCCESS,
  payload,
})

export const addCustomerFailure = error => ({
  type: ADD_CUSTOMER_FAILURE,
  payload: error,
})
export const addCustomerReset = () => ({
  type: ADD_CUSTOMER_RESET,
})

//

export const customerIdReset = () => ({
  type: CUSTOMER_ID_RESET,
})

// get Customer
export const getCustomerStart = () => ({
  type: GET_CUSTOMER_START,
})

export const getCustomerSuccess = payload => ({
  type: GET_CUSTOMER_SUCCESS,
  payload,
})

export const getCustomerFailure = error => ({
  type: GET_CUSTOMER_FAILURE,
  payload: error,
})
export const getCustomerReset = () => ({
  type: GET_CUSTOMER_RESET,
})

// edit Customer

export const editCustomerStart = CustData => ({
  type: EDIT_CUSTOMER_START,
  payload: CustData,
})

export const editCustomerSuccess = payload => ({
  type: EDIT_CUSTOMER_SUCCESS,
  payload,
})

export const editCustomerFailure = error => ({
  type: EDIT_CUSTOMER_FAILURE,
  payload: error,
})

export const editCustomerReset = () => ({
  type: EDIT_CUSTOMER_RESET,
})

// delete Customer

export const deleteCustomerStart = phone_no => ({
  type: DELETE_CUSTOMER_START,
  payload: phone_no,
})

export const deleteCustomerSuccess = payload => ({
  type: DELETE_CUSTOMER_SUCCESS,
  payload,
})

export const deleteCustomerFailure = error => ({
  type: DELETE_CUSTOMER_FAILURE,
  payload: error,
})

export const deleteCustomerReset = () => ({
  type: DELETE_CUSTOMER_RESET,
})

//view-customer

export const ViewCustomerStart = payload => {
  return {
    type: VIEW_CUSTOMER_START,
    payload,
  }
}

export const ViewCustomerSuccess = payload => ({
  type: VIEW_CUSTOMER_SUCCESS,
  payload,
})

export const ViewCustomerFailure = error => ({
  type: VIEW_CUSTOMER_FAILURE,
  payload: error,
})
export const ViewCustomerReset = () => ({
  type: VIEW_CUSTOMER_RESET,
})

// Customer Type

export const CustomerTypeStart = payload => ({
  type: GET_CUSTOMER_TYPE_START,
})

export const CustomerTypeSuccess = payload => ({
  type: GET_CUSTOMER_TYPE_SUCCESS,
  payload: payload,
})

export const CustomerTypeFailure = error => ({
  type: GET_CUSTOMER_TYPE_FAILURE,
  payload: error,
})

export const CustomerTypeReset = () => {
  type: GET_CUSTOMER_TYPE_RESET
}

// ADD CUSTOMER FOLLOWUP

export const addCustomerFollowupStart = payload => ({
  type: ADD_CUSTOMER_FOLLOWUP_START,
  payload,
})

export const addCustomerFollowupSuccess = payload => ({
  type: ADD_CUSTOMER_FOLLOWUP_SUCCESS,
  payload,
})

export const addCustomerFollowupFailure = error => ({
  type: ADD_CUSTOMER_FOLLOWUP_FAILURE,
  payload: error,
})
export const addCustomerFollowupReset = () => ({
  type: ADD_CUSTOMER_FOLLOWUP_RESET,
})

// GET CUSTOMER FOLLOUWP

export const getCustomerFollowupStart = payload => ({
  type: GET_CUSTOMER_FOLLOWUP_START,
  payload,
})

export const getCustomerFollowupSuccess = payload => ({
  type: GET_CUSTOMER_FOLLOWUP_SUCCESS,
  payload,
})

export const getCustomerFollowupFailure = error => ({
  type: GET_CUSTOMER_FOLLOWUP_FAILURE,
  payload: error,
})
export const getCustomerFollowupReset = () => ({
  type: GET_CUSTOMER_FOLLOWUP_RESET,
})

// GET CUSTOMER PROFILE
export const getCustomerProfileStart = payload => ({
  type: GET_CUSTOMER_PROFILE_START,
  payload,
})

export const getCustomerProfileSuccess = payload => ({
  type: GET_CUSTOMER_PROFILE_SUCCESS,
  payload,
})

export const getCustomerProfileFailure = error => ({
  type: GET_CUSTOMER_PROFILE_FAILURE,
  payload: error,
})
export const getCustomerProfileReset = () => ({
  type: GET_CUSTOMER_PROFILE_RESET,
})

// UPDATE CUSTOMER PROFILE
export const updateCustomerProfileStart = payload => ({
  type: UPDATE_CUSTOMER_PROFILE_START,
  payload,
})

export const updateCustomerProfileSuccess = payload => ({
  type: UPDATE_CUSTOMER_PROFILE_SUCCESS,
  payload,
})

export const updateCustomerProfileFailure = error => ({
  type: UPDATE_CUSTOMER_PROFILE_FAILURE,
  payload: error,
})
export const updateCustomerProfileReset = () => ({
  type: UPDATE_CUSTOMER_PROFILE_RESET,
})

//
export const getCustomerName = payload => ({
  type: GET_CUSTOMER_NAME_START,
  payload: payload,
})

export const getCustomerNameSuccess = payload => ({
  type: GET_CUSTOMER_NAME_SUCCESS,
  payload,
})

export const getCustomerNameFail = error => ({
  type: GET_CUSTOMER_NAME_FAILURE,
  payload: error,
})

export const getCustomerNameReset = () => ({
  type: GET_CUSTOMER_NAME_RESET,
})

export const uploadFileStart = payload => ({
  type: UPLOAD_FILE_START,
  payload,
})

export const uploadFileSuccess = payload => ({
  type: UPLOAD_FILE_SUCCESS,
  payload
})

export const uploadFileFail = payload =>({
  type: UPLOAD_FILE_FAIL,
  payload
})

export const getUploadedFileStart = payload =>({
  type: GET_UPLOADED_FILE_START,
  payload
})

export const getUploadedFileSuccess = payload =>({
  type: GET_UPLOADED_FILE_SUCCESS,
  payload
})

export const getUploadedFileFailure = payload =>({
  type: GET_UPLOADED_FILE_FAILURE,
  payload
})


export const getUploadedFileReset = () =>({
  type: GET_UPLOADED_FILE_RESET
})


export const createuploadLinkStart = (payload) =>({
  type: CREATE_UPLOAD_LINK_START,
payload
})

export const createUploadLinkSuccess = (payload) =>({
  type: CREATE_UPLOAD_LINK_SUCCESS,
  payload
})

export const createUploadLinkFail = (payload) =>({
  type: CREATE_UPLOAD_LINK_FAIL,
  payload
})

export const uploadFileLinkStart = (payload) =>({
  type: UPOLOAD_FILE_LINK_START,
  payload
})

export const uploadFileLinkSuccess = (payload) =>({
  type: UPOLOAD_FILE_LINK_SUCCESS,
  payload
})

export const uploadFileLinkFail = (payload) =>({
  type: UPOLOAD_FILE_LINK_FALSE,
  payload
})


export const custViewFilesStart = (payload) =>({
  type: CUST_VIEWFILE_START,
  payload
})

export const custViewFilesSuccess = (payload) =>({
  type: CUST_VIEWFILE_SUCCESS,
  payload
})

export const custViewFilesFail = (payload) =>({
  type: CUST_VIEWFILE_FAIL,
  payload
})

// Delete File

export const deleteFileStart = id => ({
  type: DELETE_FILE_START,
  payload: id,
})

export const deleteFileSuccess = payload => ({
  type: DELETE_FILE_SUCCESS,
  payload,
})

export const deleteFileFailure = error => ({
  type: DELETE_FILE_FAILURE,
  payload: error,
})

export const deleteFileReset = () => ({
  type: DELETE_FILE_RESET,
})

export const getBlockedCust = () =>({
  type: GET_BLOCKED_CUST
})

export const getBlockedCustSuccess = (payload) =>({
  type: GET_BLOCKED_CUST_SUCCESS,
  payload
})

export const getBlockedCustFailed = (payload) =>({
  type: GET_BLOCKED_CUST_FAILED,
  payload
})

export const editCustFiles = payload =>({
  type: EDIT_CUST_FILES,
  payload
})

export const editCustFilesSuccess = payload =>({
  type: EDIT_CUST_FILES_SUCCESS,
  payload
})

export const editCustFilesFailed = payload =>({
  type: EDIT_CUST_FILES_FAILED,
  payload
})